
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 253.23 340.64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M221.23 0a59.84 59.84 0 00-45.22 20.59l.22-.59-139 .33A37.29 37.29 0 00-.02 57.59v245.8a37.29 37.29 0 0037.25 37.25h183.74a37.29 37.29 0 0037.26-37.25V107.23c.56-.44 1.11-.88 1.65-1.34A60 60 0 00221.23 0zm20.36 303.39A20.64 20.64 0 01220.97 324H37.23a20.64 20.64 0 01-20.61-20.61V57.59A20.63 20.63 0 0137.23 37h128.58a60 60 0 0075.78 79.47zM253.23 68h-22v22.5c0 3.31-5.19 6-8.5 6s-8.5-2.69-8.5-6V68h-22c-3.31 0-6-4.69-6-8s2.69-8 6-8h22V29.5c0-3.31 5.19-6 8.5-6s8.5 2.69 8.5 6V52h22c3.31 0 6 4.69 6 8s-2.69 8-6 8z"}}),_c('path',{staticClass:"a",attrs:{"d":"M77.04 210.34h13.19a5.28 5.28 0 015.24 5.32v71.61a5.28 5.28 0 005.23 5.33h56.85a5.28 5.28 0 005.23-5.33v-71.61a5.27 5.27 0 015.23-5.32h13.22a5.35 5.35 0 003.7-9.1l-52.08-53a5.17 5.17 0 00-7.4 0l-52.07 53a5.34 5.34 0 003.66 9.1z"}}),_c('path',{staticClass:"a",attrs:{"d":"M186.43 297.41H71.8a4.81 4.81 0 110-9.62h114.63a4.81 4.81 0 110 9.62z"}})])
          )
        }
      }
    